import * as React from "react";
export function PageLayout({ children }) {
    return (
        <>
            <div className="relative">
                {children}
            </div>
            <style jsx>
                {`
                .relative {
                    overflow: auto;
                }
                `}
            </style>
        </>
    );
}
